import { gql } from "@apollo/client";

export const preSubmissionInfoFragment = gql`
    fragment PreSubmissionInfo on GetPreSubmissionInfoResponse {
        iconUrl
        isSameUser
        name
        previewUrl
        previewMediaRefs {
            signedUrl
            uploadRefId
        }
        surfaceType
        size
        hasMusic
        analytics {
            appBuild
            appSessionId
            appVersion
            documentId
            gpuFamily
            gpuOpenglVersion
            gpuVendor
            installationId
            originalDocumentId
            osType
            osVersion
        }
        trendingTagsList
        validationErrors {
            title
            message
        }
        hasLyrics
        isAIClip
    }
`;
